import { render } from "./DonationManagementDialog.vue?vue&type=template&id=6305230c&scoped=true"
import script from "./DonationManagementDialog.vue?vue&type=script&lang=js"
export * from "./DonationManagementDialog.vue?vue&type=script&lang=js"

import "./DonationManagementDialog.vue?vue&type=style&index=0&id=6305230c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6305230c"]])

export default __exports__